module.exports = __webpack_public_path__ + "img/fi-rr-syringe.124487ed.svg";